/**
 * Observes every selection after the synchronous gate (`true` blocks opening).
 * Callers own picker behavior and any menu closing inside `open`.
 */
export function runFileMenuAction({ gate, onSelect, open }) {
    const gated = gate();
    onSelect(gated);
    if (gated)
        return;
    open();
}
//# sourceMappingURL=runFileMenuAction.js.map